    import { createTheme } from "@mui/material";

    export const theme = createTheme({

        breakpoints: {
            values: {
                mobile: 570,
                tablet: 768,
                laptop: 1024,
                desktop: 1200,
                bigScreen: 1536
            }
        }
    });